import { Modal } from 'antd';
import React from 'react';
import Button from 'components/button';

export type TModal = {
  open: boolean;
  setModalVisible: (value: boolean) => void;
  handleConfirmModal: () => void;
};

export const ConfirmFileUploadModal = (props: TModal) => {
  const { open, setModalVisible, handleConfirmModal } = props;

  return (
    <Modal
      destroyOnClose
      onCancel={() => {
        setModalVisible(false);
      }}
      open={open}
      footer={null}
    >
      <div
        style={{
          minHeight: 300,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <h1>Confirmar Ação</h1>

        <p>
          Caso confirme, as informações adicionadas irão sobescrever as salvas
        </p>

        <Button
          onClick={handleConfirmModal}
          type="submit"
          buttonStyle="btn--primary"
        >
          Confirmar
        </Button>
      </div>
    </Modal>
  );
};
